import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { Challenge, Classable, HasChildren, KeyIssue } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames, entityOutlineNumberRank } from '@shapeable/utils';
import { SvgEntityNavigator, useEntityNavigatorNodes, useChallenges } from '@shapeable/ui';
import { PRIMARY, PRIMARY_DARK } from '../../theme';

const cls = classNames('challenges-navigator');

// -------- Types -------->

// -------- Props -------->

export type ChallengesNavigatorProps = Classable & HasChildren & {
}

export const ChallengesNavigatorDefaultProps: ChallengesNavigatorProps = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

// -------- Components -------->

const My = {
  Container: styled(SvgEntityNavigator)<ContainerProps>`${ContainerStyles}`,
};

export const ChallengesNavigator: React.FC<ChallengesNavigatorProps> = memo((props) => {
  const { className } = props;

  const challenges = useChallenges();

  const nodes = useEntityNavigatorNodes<Challenge, KeyIssue>({
    items: challenges,
    fieldNameChildren: 'keyIssues',
    sort: entityOutlineNumberRank,
    sortChildren: entityOutlineNumberRank,
  });
  
  return (
    <My.Container 
      useParentColorForMinorEdges={true}
      outerRing={{
        majorNode: {
          useEntityColors: true,
          circle: { strokeWidth: 11 }
        }
      }}
      innerRing={{
        minorLabelAngleOffset: -75,
        minorNode: {
          // useEntityColors: true,
          circle: {
            colors: {
              stroke: `${PRIMARY}59`,
              fill: `${PRIMARY}3c`,
              active: {
                stroke: PRIMARY_DARK,
                fill: `${PRIMARY}b6`,
              },
              hover: {
                stroke: PRIMARY_DARK,
                fill: `${PRIMARY}80`,
              }
            }
          }
        }
      }}
      initialViewBox={
        {
            "x": -17.45375733976842,
            "y": -13.13102227490805,
            "width": 863.1578947368422,
            "height": 852.6315789473684,
            "zoom": 1
        }
      }
      nodes={nodes} 
      padding={40}
      className={cls.name(className)} 
    />
  )
});

/* @ts-ignore */
ChallengesNavigator.cls = cls;
ChallengesNavigator.defaultProps = ChallengesNavigatorDefaultProps;